module.exports = __webpack_public_path__ + "img/AR.a9c572cc.svg";